var fhl = {};

$(document).ready(
    function(){
      fhl.is_mobile = ($(window).width() < 768);
      
      
      $('.modal-close, .modal-close2').click(
        function(){
          $(this).parents('.modal').fadeOut();
          return false;
        }
      );


    }
);

fhl.openModal = function(selector){
  var $modal = $(selector);
  
  
  
  
  if(fhl.is_mobile ||  true) $('body').animate({'scrollTop': 0});
  
  $modal.fadeIn(
    function(){
  	  $modal.height($(document).height());  
    }
  );
  
}


fhl.selectedColorName = function($li, color_name){
   $li.find('.selected-color-name').text(color_name);
}


fhl.semanticDropdown = function($select){
  return;
  if($select.parent().hasClass('dropdown')){
    var $select2 = $select.clone();
  	$select.parent().after($select2.dropdown({fullTextSearch: false, allowAdditions: false}));
    
    $select2.change(
      function(){
        setVariantId($(this).closest('tr'));
        if($(this).attr('name') == 'style') refreshDropDowns($(this).closest('tr'), $(this).val());
          
      }
    );
    
    
    $select.parent().remove();
  }else{
    $select.dropdown({fullTextSearch: false, allowAdditions: false}); 
  }
  
  
  
}


fhl.addAnotherStyle = function(){
	
  	var $tr = $('.garment-checkout-form').find('tbody').find('tr').first().clone();
    $tr.addClass('clone').show();
  
    applySelectEvents($tr);
  
    $tr.find('span.price').html('...');
    $tr.insertAfter($('.garment-checkout-form').find('tbody').find('tr').last());

    var t = $tr.offset().top;
    $("html, body").animate({ scrollTop: t });


    refreshDropDowns($tr, $tr.find('select[name=style]').val())

    // trigger size chart popup
    $tr.find('.size-text').click(
      function(){
        modalItemSizeTextClick($(this));
      }
    );

    refreshItemCounters();


    if(is_mobile){
      fhl.semanticDropdown($tr.find('select[name=style]')); 
      fhl.semanticDropdown($tr.find('select[name=size]')); 
      fhl.semanticDropdown($tr.find('select[name=qty]')); 
    }	

}


fhl.hideColorPriceWarning = function(){
	$('.error-message').fadeOut();
}